module.exports = __webpack_public_path__ + "static/img/b1.328bad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b1.png
// module id = uj2L
// module chunks = 1